<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" class="icon">
    <g>
      <path
        d="M14.977,23.28l1-13.28h3.149c0.328,0,0.574-0.16,0.82-0.48c0.082-0.32,0.082-0.64-0.082-0.88 c-2.296-3.28-6.144-6.4-6.308-6.48C13.398,2.082,13.164,2.008,13,2.003C12.995,2.003,12.988,2,12.983,2c0,0,0,0,0,0s0,0,0,0 c-0.164,0-0.41,0.08-0.492,0.16c-0.164,0.08-4.023,3.12-6.319,6.48C6.007,8.96,5.925,9.28,6.089,9.52C6.253,9.84,6.499,10,6.827,10 h3.15l1,13.28c0.32,0.4,1.126,0.72,2.006,0.72C13.783,24,14.657,23.76,14.977,23.28z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "add-item-outline",
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
